import React from 'react';
import { LoadingModal as LoadingModalType } from '@/types/modal';
import { LoadingModal } from '@/components/molecules/common/Modal';

const View: React.FC<{ modal: LoadingModalType }> = ({ modal }) => {
  return (
    <LoadingModal
      title={modal.title}
      onClose={modal.onClose}
    />
  );
};

export default View;
